import * as React from "react";
const SvgIcon28 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 14 14" {...props}><path d="M29 22a7 7 0 1 0 7 7 7 7 0 0 0-7-7Zm3.709 5.284-4.151 4.15a.507.507 0 0 1-.718 0l-2.551-2.551a.507.507 0 0 1 .718-.718l2.193 2.193 3.792-3.792a.507.507 0 1 1 .718.718Z" transform="translate(-22 -22)" style={{
    fill: "#fff"
  }} /></svg>;
export default SvgIcon28;